import React, { useState } from 'react';

const SwitchButton = ({ id,initialChecked = false, onChange, label }) => {
  const [isChecked, setIsChecked] = useState(initialChecked);

  const handleToggle = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    if (onChange) onChange(newCheckedState); 
  };

  return (
    <div className="switch-container" onClick={handleToggle}>
      <label style={{color:'#1972B7'}} htmlFor={label}>{label}</label>
      <div className={`switch ${isChecked ? 'checked' : ''}`}>
        <div className="switch-thumb"></div>
      </div>
    </div>
  );
};

export default SwitchButton;
